// Manual per-station relevance overlay for ZephyrProvider (spec 24, D4a/N28a).
// Keyed by Zephyr station id — names are reference-only, not used for lookup.
// Bonus (-500): exposed headlands/offshore islands the coast/elevation score under-rates.
// Penalty (+500): sheltered-but-elevated sites the elevation credit over-rates.

const ADJUST = {
  '6631d5ddcf26372d5b804138': -500, // Farewell Spit
  '6631d5ddcf26372d5b80417e': -500, // Stephens Island
  '6631d5ddcf26372d5b8040f7': -500, // Brothers Island
  '6631d5ddcf26372d5b804108': -500, // Separation Point
  '665aaf5e831ba158c598158b': -500, // Tongue Point
  '6631d5ddcf26372d5b804143': -500, // Mana Island
  '6631d5ddcf26372d5b80417f': -500, // Cape Campbell
  '6631d5ddcf26372d5b80418c': -500, // Palliser
  '6631d5ddcf26372d5b804074': -500, // Mahia Radar
  '6631d5ddcf26372d5b804081': -500, // Cape Kidnappers
  '6631d5ddcf26372d5b8040bc': -500, // Hicks Bay
  '6631d5ddcf26372d5b804095': -500, // Great Mercury Island
  '6631d5ddcf26372d5b8040da': -500, // Tutukaka Harbour
  '6631d5ddcf26372d5b8041b4': -500, // Le Bons Bay
  '6631d5ddcf26372d5b804165': -500, // Puysegur Point
  '6631d5ddcf26372d5b804171': -500, // Kaikoura
  '6631d5ddcf26372d5b80409c': -500, // Godley Head
  '677e8cd64b1b7d049fcc6021': 500,  // Whanganui Inlet
  '6631d5ddcf26372d5b8040f8': 500,  // Hoddy Rd
  '6631d5ddcf26372d5b80418a': 500,  // Porirua City
  '6631d5ddcf26372d5b8041a3': 500,  // Paekakariki
};

export function adjustFor(id) {
  return ADJUST[id] ?? 0;
}
